import { useState } from 'react'
import SendTokenModal from './SendTokenModal'
import ReceiveTokenModal from './ReceiveTokenModal'
import { ArrowUp, ArrowDown } from 'lucide-react'

interface SendSwapReceiveComboProps {
	scannedWallet?: string
}

export default function SendSwapReceiveCombo({
												 scannedWallet
											 }: SendSwapReceiveComboProps) {
	const [sendModalOpen, setSendModalOpen] = useState(false)
	const [receiveModalOpen, setReceiveModalOpen] = useState(false)

	return (
		<div className="primary-actions flex items-center justify-between gap-2">
			{/* Send Button */}
			<button
				onClick={() => setSendModalOpen(true)}
				className="send-btn w-[calc(50%-4px)] h-[42px] rounded-[21px] bg-[#EF4444] shadow-[0px_4px_36px_0px_#DC262699] text-[#ffffff] text-sm leading-4 font-semibold font-figtree"
			>
				Send
			</button>

			{/* Send Modal */}
			<SendTokenModal
				isOpen={sendModalOpen}
				onClose={() => setSendModalOpen(false)}
				scannedWallet={scannedWallet}
			/>
			
			{/* Receive Button */}
			<button
				onClick={() => setReceiveModalOpen(true)}
				className="receive-btn w-[calc(50%-4px)] border-[#686767] border h-[42px] rounded-[21px] bg-[rgba(255,255,255,0.1)] text-[#ffffff] text-sm leading-4 font-semibold font-figtree"
			>
				Receive
			</button>

			{/* Receive Modal */}
			<ReceiveTokenModal
				isOpen={receiveModalOpen}
				onClose={() => setReceiveModalOpen(false)}
			/>
		</div>
	)
}